import React from 'react';
import PropTypes from 'prop-types';
import { Route, IndexRedirect, IndexRoute } from 'react-router';
import { Tracking } from 'web-core/src/tracking';
import TranslationProvider from 'client/components/translationProvider';
import StrideHeaderWrapper from 'client/components/strideHeaderWrapper';
import Breadcrumb from 'client/components/strideHeaderBreadcrumbWrapper';
import CrossSellContainer from 'client/components/crossSellContainer';

import App from './app';
/* eslint-disable import/no-named-as-default */
// TODO: Change name of presentational component exports to keep tests working
import ZipcodeLookupPageContainer from './zipcodeLookupPageContainer';
import LocationUnsupportedPage from './locationUnsupportedPage';
import CountyPage from './countyPage';
import ApplicantsPage from './applicantsPage';
import PlanDetailPage from './planDetailPage';
import AccountPage from './accountPage';
import ResetPage from './resetPage';

function bindPageViewTracking() {
  return () => {
    Tracking.trackPageView();
  };
}

const Shw = ({ children }) => (
  <StrideHeaderWrapper showPhone={false} noShadow>
    {children}
  </StrideHeaderWrapper>
);

Shw.propTypes = {
  children: PropTypes.element.isRequired,
};

export default (
  <Route component={App}>
    <Route component={TranslationProvider} keys={['app', 'common', 'vision']}>
      <Route component={Shw}>
        <Route path="/" component={ZipcodeLookupPageContainer} onEnter={bindPageViewTracking()} />
      </Route>
      <Route component={CrossSellContainer} appType="vision">
        <Route component={Breadcrumb} steps={['location', 'applicants', 'plans']}>
          <Route path="onboarding">
            <IndexRedirect to="/onboarding/location" />
            <Route
              path="location"
              component={ZipcodeLookupPageContainer}
              onEnter={bindPageViewTracking()} />
            <Route
              path="unsupported"
              component={LocationUnsupportedPage}
              onEnter={bindPageViewTracking()} />
            <Route path="county" component={CountyPage} onEnter={bindPageViewTracking()} />
            <Route path="applicants" component={ApplicantsPage} onEnter={bindPageViewTracking()} />
            <Route path="plans" component={PlanDetailPage} onEnter={bindPageViewTracking()} />
          </Route>
        </Route>
        <Route path="onboarding/account">
          <IndexRoute component={AccountPage} onEnter={bindPageViewTracking()} />
          <Route path="reset" component={ResetPage} onEnter={bindPageViewTracking()} />
        </Route>
      </Route>
    </Route>
  </Route>
);
